export interface RiskDetailBPKLiability {
  riskBPKLiability: {
    occupationCode: string;
    occupationDescription?: string;
    business?: string;
    numberOfEmployees?: number;
    limitOfLiability?: number;
    liabilityExcess?: number;
    productsLiability?: number;
    goodsInPhysicalControl?: number;
    annualTurnover?: number;
    propertyOwners?: string;
    propertyOwnersDesc?: string;
    propertyValue?: number;
    paymentToContractors?: number;
    adjustmentIndicator?: boolean;
    adjustmentPercentage?: number;
  };
}

export interface RiskDetailBPKGeneralPropertyMachineryBreakdown {
  riskBPKGeneralPropertyMachineryBreakdown: {
    occupationCode: string;
    occupationDescription: string;
    business?: string;
    govermentResidential?: string;
    generalProperty?: {
      generalPropertySumInsured: number;
      generalPropertyExcess: number;
      FSLArea?: string;
      FSLAreaDesc?: string;
      itemList: {
        itemGroup: string;
        itemDescription: string;
        serialNumber: string;
        itemSI: number;
      }[];
    };
    machineryBreakdown?: {
      machineryBreakDownSI?: number;
      machineryBreakDownExcess?: number;
      deteriorationOfStockSI?: number;
      goodsInTransitSI?: number;
      goodsInTransitExcess?: number;
      machinerySpecifiedItemSI?: number;
      machineryBlanketSI?: number;
      machineryBlanketNumberOfItems?: number;
      machineryItems?: Array<unknown>;
    };
  };
}

export interface RiskDetailBPKFireBusinessInterruption {
  riskBPKFireBusinessInterruption: {
    occupationCode: string;
    occupationDescription: string;
    business?: string;
    govermentResidential?: string;
    fire?: {
      construction: string;
      yearBuilt: string;
      sprinkler: string;
      townWater?: string;
      buildingSI?: number;
      /** @note MS to add this into the RAML spec */
      buildingExcess?: number;
      contentsSI?: number;
      contentsExcess?: number;
      flood: string;
      adjustmentIndicator?: boolean;
      adjustmentPercentage?: number;
    };
    businessInterruption?: {
      /** @todo MS to convert this to number */
      indemnityPeriod: number;
      grossIncomeSI: number;
      grossIncomeExcess: number;
      ICOWSI?: number;
      weeklyIncomeSI?: number;
      weeksCovered?: number;
      claimsPreparationCosts?: number;
      OSAcctRecSI?: number;
      OSAcctRecExcess?: number;
      adjustmentIndicator?: boolean;
      adjustmentPercentage?: number;
    };
  };
}

export interface RiskDetailBPKTheftMoneyGlass {
  riskBPKTheftMoneyGlass: {
    occupationCode: string;
    occupationDescription: string;
    business?: string;
    govermentResidential?: string;
    theft?: {
      contentsSI: number;
      theftExcess: number;
      tobaccoSI?: number;
      security: string;
    };
    money?: {
      moneyExcess: number;
      blanketCover: string;
      blanketCoverSI: number;
    };
    glass?: {
      glassExcess: number;
    };
  };
}

export interface RiskDetailBPKEmployeeDishonestyTaxAuditTransit {
  riskBPKEmployeeDishonestyTaxAuditTransit: {
    occupationCode: string;
    occupationDescription: string;
    business: string;
    fidelity?: {
      fidelitySI: number;
      fidelityExcess: number;
      employees: number;
      adjustmentIndicator: boolean;
      adjustmentPercentage: number;
    };
    taxAudit?: {
      taxAuditSI: number;
      taxAuditExcess: number;
      turnover: number;
      adjustmentIndicator: boolean;
      adjustmentPercentage: number;
    };
    transit?: {
      transitSI: number;
      transitExcess: number;
      annualSendings: number;
      adjustmentIndicator: boolean;
      adjustmentPercentage: number;
    };
  };
}

export enum RiskClassCode {
  Liability = 'BPP',
  PortableItems = 'BGM',
  BuildingAndContents = 'BFP',
  TheftMoneyGlass = 'BPO',
  TaxAudit = 'BAC',
}
